const LOCALHOST_API_DOMAIN = "localhost";
const STAGING_API_DOMAIN = ".wsli.dev";
const PRODUCTION_API_DOMAIN = ".noom.com";

export default function getApiDomain() {
  const env = __NODE_ENV__;
  switch (env) {
    case "local":
      return LOCALHOST_API_DOMAIN;
    case "production":
      return PRODUCTION_API_DOMAIN;
    case "staging":
    default:
      return STAGING_API_DOMAIN;
  }
}
